<template>

  <v-select
    v-model="selected"
    :items="allDivisions"
    item-value="id"
    item-text="label"
    outlined
    dense
    :clearable="clearable"
    :chips="multiple"
    :label="getLabel()"
    :multiple="multiple"
    :prepend-icon="prependIcon"
    :disabled="disabled"
    menu-props="auto, overflowX, overflowY"
    @change="$emit('select-item', selected)"
  />

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    initDivision: {
      type: String,
      default: ''
    },
    initDivisions: {
      type: Array,
      default: () => []
    },
    clearable: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    prependIcon: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selected: null
    }
  },
  computed: {
    ...mapGetters([ 'allDivisions' ])
  },
  watch: {
    initDivision() {
      this.init()
    },
    initDivisions() {
      this.init()
    }
  },
  created() {
    this.init()
    this.$store.dispatch('initDivisions')
  },
  methods: {
    getLabel() {
      if (this.disabled) {
        return ''
      } else {
        return `Select ${this.multiple ? this.$t('common.divisions.plural') : this.$t('common.divisions.singular') }`
      }
    },
    init() {
      this.selected = this.multiple
        ? (this.initDivisions || [])
        : (this.initDivision || '')
    }
  }
}
</script>
